import axios from 'axios';
import { baseUrl_SPB } from '../BaseUrl';

const AddBreaksForBookedItem = async (bookedItem, token) => {
  const response = await axios.post(
    `${baseUrl_SPB}/api/v1/rostertimeallocation/savebreaks`,
    bookedItem,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response?.data;
};

export default AddBreaksForBookedItem;